import React from 'react';
import Icon from '../../../components/AppIcon';

const MilestoneCard = ({ milestone, isCompleted }) => {
  return (
    <div className={`relative bg-card rounded-xl p-6 border-2 transition-all ${
      isCompleted 
        ? 'border-success shadow-lg' 
        : 'border-border hover:border-primary/50'
    }`}>
      {isCompleted && (
        <div className="absolute -top-3 -right-3 w-12 h-12 bg-success rounded-full flex items-center justify-center shadow-lg">
          <Icon name="Check" size={24} color="white" />
        </div>
      )}
      <div className="flex items-start gap-4">
        <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${
          isCompleted 
            ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
        }`}>
          <Icon name={milestone?.icon} size={28} />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">{milestone?.title}</h3>
          <p className="text-sm text-muted-foreground mb-4">{milestone?.description}</p>
          <div className="space-y-2">
            <div className="flex items-center justify-between text-sm">
              <span className="text-muted-foreground">Progress</span>
              <span className="font-medium text-foreground">
                {milestone?.current} / {milestone?.target} {milestone?.unit}
              </span>
            </div>
            <div className="w-full bg-muted rounded-full h-3 overflow-hidden">
              <div 
                className={`h-full rounded-full transition-all duration-500 ${
                  isCompleted 
                    ? 'bg-success' :'bg-gradient-to-r from-primary to-secondary'
                }`}
                style={{ width: `${(milestone?.current / milestone?.target) * 100}%` }}
              />
            </div>
          </div>
          {milestone?.reward && (
            <div className="mt-4 pt-4 border-t border-border">
              <div className="flex items-center gap-2 text-sm">
                <Icon name="Gift" size={16} className="text-accent" />
                <span className="text-muted-foreground">Reward: </span>
                <span className="font-medium text-foreground">{milestone?.reward}</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MilestoneCard;